import { ChangeDetectionStrategy, Component, input } from "@angular/core";
import { AccountType } from "@front/m19-api-client";

@Component({
  selector: "app-account-type-formatter",
  imports: [],
  template: `@for (type of values(); track type) {
    {{ type === AccountType.SELLER ? "Seller" : "Vendor" }}
    @if (!$last) {
      <span class="text-gray-400">, </span>
    }
  }`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccountTypeFormatterComponent {
  readonly AccountType = AccountType;
  readonly values = input.required<AccountType[]>();
}
